/* ============================================================
   hg-cap-customizer.js — Hatgoods Cap Customizer  v3
   assets/hg-cap-customizer.js
   ------------------------------------------------------------
   One patch per velcro panel. The patch is rendered into a
   fixed slot — no drag, no resize, no rotation.
   ============================================================ */
(function () {
  'use strict';

  var FACET_ORDER = ['type', 'department', 'colour', 'color', 'size', 'head size', 'brand', 'shape', 'backside', 'brim', 'category', 'age'];

  function money(cents, format) {
    var value = (cents || 0) / 100;
    function withComma(n, dec) {
      var parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    }
    return (format || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, token) {
      switch (token) {
        case 'amount': return withComma(value, 2);
        case 'amount_no_decimals': return withComma(Math.round(value), 0);
        case 'amount_with_comma_separator': return withComma(value, 2).replace(/,/g, '§').replace(/\./g, ',').replace(/§/g, '.');
        case 'amount_no_decimals_with_comma_separator': return withComma(Math.round(value), 0).replace(/,/g, '.');
        default: return withComma(value, 2);
      }
    });
  }

  function el(tag, cls, html) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (html != null) node.innerHTML = html;
    return node;
  }

  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function titleCase(str) {
    return String(str).replace(/(^|\s|-)\w/g, function (m) { return m.toUpperCase(); });
  }

  function parseSlot(str) {
    var p = String(str || '33,26,34,26').split(',').map(function (n) { return parseFloat(n) || 0; });
    return { x: p[0], y: p[1], w: p[2], h: p[3] };
  }

  /* ---------------------------------------------------------- */

  function Customizer(root) {
    this.root = root;
    var script = document.querySelector('[data-hg-cc-data="' + root.dataset.sectionId + '"]');
    if (!script) return;

    try { this.data = JSON.parse(script.textContent); } catch (e) { return; }

    this.designable = String(this.data.designableViews == null ? '0' : this.data.designableViews)
      .split(',')
      .map(function (n) { return parseInt(n, 10); })
      .filter(function (n) { return !isNaN(n); });
    if (!this.designable.length) this.designable = [0];

    this.state = {
      cap: this.data.caps[0] || null,
      variantId: null,
      view: 0,
      // one patch per view: { view -> patch }
      picks: {},
      qty: 1,
      facets: {},
      sort: 'relevance',
      productQuery: '',
      patchQuery: '',
      patchChip: 'all'
    };

    this.dom = {
      capImage: root.querySelector('[data-hg-cap-image]'),
      canvas: root.querySelector('[data-hg-canvas]'),
      slot: root.querySelector('[data-hg-slot]'),
      patchImage: root.querySelector('[data-hg-patch-image]'),
      thumbs: root.querySelector('[data-hg-thumbs]'),
      thumbsTop: root.querySelector('[data-hg-thumbs-top]'),
      layerList: root.querySelector('[data-hg-layer-list]'),
      adderLabel: root.querySelector('[data-hg-adder-label]'),
      price: root.querySelector('[data-hg-price]'),
      priceMobile: root.querySelector('[data-hg-price-mobile]'),
      msg: root.querySelector('[data-hg-msg]'),
      form: root.querySelector('[data-hg-form]'),
      atc: root.querySelector('[data-hg-atc]'),
      barAtc: root.querySelector('[data-hg-bar-atc]'),
      sizes: root.querySelector('[data-hg-sizes]'),
      sizeRow: root.querySelector('[data-hg-size-row]'),
      productGrid: root.querySelector('[data-hg-product-grid]'),
      productCount: root.querySelector('[data-hg-product-count]'),
      facets: root.querySelector('[data-hg-facets]'),
      patchGrid: root.querySelector('[data-hg-patch-grid]'),
      patchChips: root.querySelector('[data-hg-patch-chips]')
    };

    this.portalModals();
    this.bind();
    this.buildFacets();
    this.renderProductGrid();
    this.buildChips();
    this.renderPatchGrid();
    this.selectCap(this.state.cap, true);
  }

  Customizer.prototype.qa = function (sel) { return Array.prototype.slice.call(this.root.querySelectorAll(sel)); };

  /* ---------- modal portalling ----------
     Debutify's header wrapper uses transform / will-change, which makes
     it a containing block. A fixed overlay nested inside it paints under
     the header. Moving the overlays to <body> escapes every such context. */

  Customizer.prototype.portalModals = function () {
    var self = this;
    this.modals = {};
    this.qa('[data-hg-modal]').forEach(function (modal) {
      modal.dataset.hgOwner = self.root.id;
      document.body.appendChild(modal);
      self.modals[modal.dataset.hgModal] = modal;
    });
  };

  Customizer.prototype.eachModal = function (fn) {
    var self = this;
    Object.keys(this.modals || {}).forEach(function (k) { fn(self.modals[k]); });
  };

  /* ---------- events ---------- */

  Customizer.prototype.bind = function () {
    var self = this;

    function onClick(e) {
      var t = e.target;
      if (!(t instanceof Element)) return;

      if (t.closest('[data-hg-modal-close]')) { self.closeModals(); return; }
      if (t.closest('[data-hg-open-products]')) { self.openModal('products'); return; }
      if (t.closest('[data-hg-open-volume]')) { self.openModal('volume'); return; }
      if (t.closest('[data-hg-open-library]')) { self.openLibrary(); return; }
      if (t.closest('[data-hg-view-prev]')) { self.setView(self.state.view - 1); return; }
      if (t.closest('[data-hg-view-next]')) { self.setView(self.state.view + 1); return; }
      if (t.closest('[data-hg-save]')) { self.saveDesign(t.closest('[data-hg-save]')); return; }
      if (t.closest('[data-hg-bar-atc]')) {
        self.dom.form.requestSubmit ? self.dom.form.requestSubmit() : self.dom.form.submit();
        return;
      }

      var act = t.closest('[data-act]');
      if (act) { self.pickAction(act.dataset.act, parseInt(act.dataset.pickView, 10)); return; }

      var size = t.closest('[data-size]');
      if (size) { self.setVariant(parseInt(size.dataset.size, 10)); return; }

      var thumb = t.closest('[data-view]');
      if (thumb) { self.setView(parseInt(thumb.dataset.view, 10)); return; }

      var prodCard = t.closest('[data-product]');
      if (prodCard) {
        var cap = self.data.caps.find(function (c) { return String(c.id) === prodCard.dataset.product; });
        if (cap) { self.selectCap(cap); self.closeModals(); }
        return;
      }

      var patchCard = t.closest('[data-patch]');
      if (patchCard) {
        var patch = self.data.patches.find(function (p) { return String(p.id) === patchCard.dataset.patch; });
        if (patch) { self.choosePatch(patch); self.closeModals(); }
        return;
      }

      var chip = t.closest('[data-chip]');
      if (chip) {
        self.state.patchChip = chip.dataset.chip;
        self.buildChips();
        self.renderPatchGrid();
      }
    }

    function onInput(e) {
      var t = e.target;
      if (!(t instanceof Element)) return;
      if (t.matches('[data-hg-product-search]')) { self.state.productQuery = t.value.toLowerCase(); self.renderProductGrid(); }
      if (t.matches('[data-hg-patch-search]')) { self.state.patchQuery = t.value.toLowerCase(); self.renderPatchGrid(); }
    }

    function onChange(e) {
      var t = e.target;
      if (!(t instanceof Element)) return;
      if (t.matches('[data-hg-product-sort]')) { self.state.sort = t.value; self.renderProductGrid(); }
      if (t.matches('[data-facet]')) {
        if (t.value) self.state.facets[t.dataset.facet] = t.value;
        else delete self.state.facets[t.dataset.facet];
        t.classList.toggle('is-set', !!t.value);
        self.renderProductGrid();
      }
    }

    [this.root].concat(Object.keys(this.modals).map(function (k) { return self.modals[k]; }))
      .forEach(function (scope) {
        scope.addEventListener('click', onClick);
        scope.addEventListener('input', onInput);
        scope.addEventListener('change', onChange);
      });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') self.closeModals();
    });

    this.dom.capImage.addEventListener('load', function () { self.renderSlot(); });
    window.addEventListener('resize', function () { self.renderSlot(); });

    this.dom.form.addEventListener('submit', function (e) { self.addToCart(e); });
  };

  /* ---------- modals ---------- */

  Customizer.prototype.openModal = function (name) {
    this.closeModals();
    var m = this.modals[name];
    if (!m) return;
    m.hidden = false;
    document.documentElement.classList.add('hg-cc-locked');
  };

  Customizer.prototype.closeModals = function () {
    this.eachModal(function (m) { m.hidden = true; });
    document.documentElement.classList.remove('hg-cc-locked');
  };

  Customizer.prototype.openLibrary = function () {
    // always land on a view that actually has a panel
    if (this.designable.indexOf(this.state.view) < 0) this.setView(this.designable[0]);
    this.openModal('library');
  };

  Customizer.prototype.flash = function (text, isError) {
    var m = this.dom.msg;
    m.textContent = text || '';
    m.classList.toggle('is-error', !!isError);
    if (text) {
      clearTimeout(this._flashTimer);
      this._flashTimer = setTimeout(function () { m.textContent = ''; m.classList.remove('is-error'); }, 4000);
    }
  };

  /* ---------- cap ---------- */

  Customizer.prototype.selectCap = function (cap, initial) {
    if (!cap) { this.flash('No caps found in the selected collection.', true); return; }
    this.state.cap = cap;

    var firstAvailable = cap.variants.find(function (v) { return v.available; }) || cap.variants[0];
    this.state.variantId = firstAvailable ? firstAvailable.id : null;

    // drop picks on views this cap does not have
    var picks = this.state.picks;
    Object.keys(picks).forEach(function (k) {
      if (parseInt(k, 10) >= cap.images.length) delete picks[k];
    });

    this.renderThumbs();
    this.renderSizes();
    this.setView(this.designable[0] || 0);
    this.updatePrice();
    if (!initial) this.flash(cap.title + ' selected.');
  };

  Customizer.prototype.setVariant = function (id) {
    this.state.variantId = id;
    this.renderSizes();
    this.updatePrice();
  };

  Customizer.prototype.setView = function (index) {
    var images = this.state.cap.images;
    if (!images.length) return;
    var i = (index + images.length) % images.length;
    this.state.view = i;
    this.dom.capImage.src = images[i];
    this.dom.capImage.alt = this.state.cap.title + ' — ' + (this.data.viewLabels[i] || 'view ' + (i + 1));
    this.qa('[data-view]').forEach(function (t) { t.classList.toggle('is-active', parseInt(t.dataset.view, 10) === i); });
    this.renderSlot();
    this.renderPickList();
  };

  Customizer.prototype.viewIsDesignable = function (i) {
    return this.designable.indexOf(i == null ? this.state.view : i) > -1;
  };

  Customizer.prototype.slot = function (view) {
    var v = view == null ? this.state.view : view;
    return parseSlot(this.data.slots[String(v)] || this.data.slots['0']);
  };

  /* The cap photo is object-fit:contain inside the canvas, so it usually
     letterboxes. Slot percentages are authored against the PHOTO, so we
     measure the photo's rendered box first and place the slot inside it.
     Without this the patch drifts whenever the cap image aspect changes. */
  Customizer.prototype.photoBox = function () {
    var img = this.dom.capImage;
    var rect = this.dom.canvas.getBoundingClientRect();
    var nw = img.naturalWidth, nh = img.naturalHeight;
    if (!nw || !nh || !rect.width || !rect.height) {
      return { left: 0, top: 0, width: rect.width || 0, height: rect.height || 0 };
    }
    var scale = Math.min(rect.width / nw, rect.height / nh);
    var w = nw * scale, h = nh * scale;
    return { left: (rect.width - w) / 2, top: (rect.height - h) / 2, width: w, height: h };
  };

  /* Renders the fixed patch slot. Position comes entirely from settings —
     nothing the customer does can move it. */
  Customizer.prototype.renderSlot = function () {
    var s = this.slot();
    var b = this.photoBox();
    var box = this.dom.slot;

    box.style.left = (b.left + b.width * s.x / 100) + 'px';
    box.style.top = (b.top + b.height * s.y / 100) + 'px';
    box.style.width = (b.width * s.w / 100) + 'px';
    box.style.height = (b.height * s.h / 100) + 'px';

    var designable = this.viewIsDesignable();
    var pick = this.state.picks[this.state.view];

    box.classList.toggle('is-hidden', !designable);
    box.classList.toggle('is-filled', !!pick);

    if (pick && pick.art) {
      this.dom.patchImage.src = pick.art;
      this.dom.patchImage.alt = pick.title;
      this.dom.patchImage.hidden = false;
    } else {
      this.dom.patchImage.removeAttribute('src');
      this.dom.patchImage.hidden = true;
    }
  };

  Customizer.prototype.renderThumbs = function () {
    var self = this;
    [this.dom.thumbs, this.dom.thumbsTop].forEach(function (holder) {
      if (!holder) return;
      holder.innerHTML = '';
      self.state.cap.thumbs.forEach(function (src, i) {
        var b = el('button', 'hg-cc__thumb');
        b.type = 'button';
        b.dataset.view = i;
        b.setAttribute('aria-label', self.data.viewLabels[i] || 'View ' + (i + 1));
        var img = new Image();
        img.src = src; img.alt = ''; img.loading = 'lazy';
        b.appendChild(img);
        holder.appendChild(b);
      });
    });
  };

  Customizer.prototype.renderSizes = function () {
    var self = this;
    var variants = this.state.cap.variants;
    var single = variants.length <= 1;
    this.dom.sizes.hidden = single;
    if (single) return;

    this.dom.sizeRow.innerHTML = '';
    variants.forEach(function (v) {
      var b = el('button', 'hg-cc__size' + (v.id === self.state.variantId ? ' is-active' : ''), esc(v.title));
      b.type = 'button';
      b.dataset.size = v.id;
      b.disabled = !v.available;
      self.dom.sizeRow.appendChild(b);
    });
  };

  /* ---------- patch pick ---------- */

  Customizer.prototype.choosePatch = function (patch) {
    if (!patch.art) { this.flash('That patch has no image yet. Add one in Shopify admin.', true); return; }
    if (patch.available === false) { this.flash('That patch is out of stock right now.', true); return; }

    var replaced = !!this.state.picks[this.state.view];
    this.state.picks[this.state.view] = patch;

    this.renderSlot();
    this.renderPickList();
    this.updatePrice();
    this.flash(replaced ? patch.title + ' swapped in.' : patch.title + ' added.');
  };

  Customizer.prototype.pickAction = function (act, view) {
    if (act === 'remove') {
      delete this.state.picks[view];
      if (view === this.state.view) this.renderSlot();
      this.renderPickList();
      this.updatePrice();
    }
    if (act === 'change') {
      this.setView(view);
      this.openModal('library');
    }
  };

  Customizer.prototype.renderPickList = function () {
    var self = this;
    var list = this.dom.layerList;
    var views = Object.keys(this.state.picks).map(Number).sort(function (a, b) { return a - b; });

    list.innerHTML = '';

    if (!views.length) {
      list.appendChild(el('li', 'hg-cc__empty', 'No patch on the cap yet.'));
    } else {
      views.forEach(function (v) {
        var p = self.state.picks[v];
        var li = el('li');
        var row = el('div', 'hg-cc__pick-row');

        var media = el('span', 'hg-cc__pick-media');
        if (p.thumb) {
          var img = new Image();
          img.src = p.thumb; img.alt = ''; img.loading = 'lazy';
          media.appendChild(img);
        }
        row.appendChild(media);

        var name = el('span', 'hg-cc__pick-name');
        name.innerHTML = esc(p.title) +
          '<span class="hg-cc__pick-meta">' + esc(self.data.viewLabels[v] || 'View ' + (v + 1)) +
          (p.price ? ' · + ' + money(p.price, self.data.moneyFormat) : ' · Included') + '</span>';
        row.appendChild(name);

        var acts = el('div', 'hg-cc__pick-acts');
        acts.innerHTML =
          '<button type="button" data-act="change" data-pick-view="' + v + '" aria-label="Choose a different patch"><svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M4 12a8 8 0 0 1 13.7-5.7L20 8"/><path d="M20 4v4h-4"/><path d="M20 12a8 8 0 0 1-13.7 5.7L4 16"/><path d="M4 20v-4h4"/></svg></button>' +
          '<button type="button" data-act="remove" data-pick-view="' + v + '" aria-label="Remove patch"><svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M4 7h16"/><path d="M10 4h4"/><path d="M6 7l1 13h10l1-13"/></svg></button>';
        row.appendChild(acts);

        li.appendChild(row);
        list.appendChild(li);
      });
    }

    if (this.dom.adderLabel) {
      this.dom.adderLabel.textContent = this.state.picks[this.state.view]
        ? (this.data.labels.change || 'Choose a different patch')
        : (this.data.labels.add || 'Choose a patch');
    }
  };

  /* ---------- product modal ---------- */

  Customizer.prototype.buildFacets = function () {
    var map = {};
    this.data.caps.forEach(function (cap) {
      (cap.tags || []).forEach(function (tag) {
        var i = tag.indexOf(':');
        if (i < 1) return;
        var key = tag.slice(0, i).trim().toLowerCase();
        var val = tag.slice(i + 1).trim();
        if (!val) return;
        (map[key] = map[key] || new Set()).add(val);
      });
      if (cap.vendor) (map.brand = map.brand || new Set()).add(cap.vendor);
    });

    var keys = Object.keys(map).sort(function (a, b) {
      var ia = FACET_ORDER.indexOf(a), ib = FACET_ORDER.indexOf(b);
      if (ia < 0) ia = 99;
      if (ib < 0) ib = 99;
      return ia - ib || a.localeCompare(b);
    });

    this.dom.facets.innerHTML = keys.map(function (key) {
      var opts = Array.from(map[key]).sort().map(function (v) { return '<option value="' + esc(v) + '">' + esc(v) + '</option>'; }).join('');
      return '<select class="hg-cc__facet" data-facet="' + esc(key) + '" aria-label="' + esc(titleCase(key)) + '">' +
        '<option value="">' + esc(titleCase(key)) + '</option>' + opts + '</select>';
    }).join('');
  };

  Customizer.prototype.filteredCaps = function () {
    var s = this.state;
    var q = s.productQuery;

    var list = this.data.caps.filter(function (cap) {
      if (q && (cap.title + ' ' + cap.vendor).toLowerCase().indexOf(q) < 0) return false;
      return Object.keys(s.facets).every(function (key) {
        var want = s.facets[key].toLowerCase();
        if (key === 'brand' && cap.vendor && cap.vendor.toLowerCase() === want) return true;
        return (cap.tags || []).some(function (tag) {
          var i = tag.indexOf(':');
          return i > 0 && tag.slice(0, i).trim().toLowerCase() === key && tag.slice(i + 1).trim().toLowerCase() === want;
        });
      });
    });

    if (s.sort === 'price-asc') list.sort(function (a, b) { return a.price - b.price; });
    if (s.sort === 'price-desc') list.sort(function (a, b) { return b.price - a.price; });
    if (s.sort === 'title') list.sort(function (a, b) { return a.title.localeCompare(b.title); });
    return list;
  };

  Customizer.prototype.renderProductGrid = function () {
    var self = this;
    var list = this.filteredCaps();
    this.dom.productCount.textContent = list.length + (list.length === 1 ? ' product' : ' products');
    this.dom.productGrid.innerHTML = '';

    if (!list.length) {
      this.dom.productGrid.appendChild(el('p', 'hg-cc__empty', 'No caps match those filters. Clear one to see more.'));
      return;
    }

    list.forEach(function (cap) {
      var b = el('button', 'hg-cc__card' + (self.state.cap && cap.id === self.state.cap.id ? ' is-active' : ''));
      b.type = 'button';
      b.dataset.product = cap.id;
      b.innerHTML =
        '<span class="hg-cc__card-media">' +
          '<span class="hg-cc__card-check"><svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="3"><path d="M5 13l4 4 10-10"/></svg></span>' +
          (cap.card ? '<img src="' + esc(cap.card) + '" alt="" loading="lazy">' : '<span class="hg-cc__card-fallback">No image</span>') +
        '</span>' +
        (cap.vendor ? '<span class="hg-cc__card-vendor">' + esc(cap.vendor) + '</span>' : '') +
        '<span class="hg-cc__card-title">' + esc(cap.title) + '</span>' +
        '<span class="hg-cc__card-price">' + money(cap.price, self.data.moneyFormat) + '</span>';
      self.dom.productGrid.appendChild(b);
    });
  };

  /* ---------- patch library ---------- */

  Customizer.prototype.patchCategories = function () {
    var set = new Set();
    var popular = false;
    this.data.patches.forEach(function (p) {
      (p.tags || []).forEach(function (tag) {
        if (/^popular$/i.test(tag)) { popular = true; return; }
        var i = tag.indexOf(':');
        if (i > 0 && tag.slice(0, i).trim().toLowerCase() === 'cat') set.add(tag.slice(i + 1).trim());
      });
    });
    var cats = Array.from(set).sort();
    return [{ key: 'all', label: 'All' }]
      .concat(popular ? [{ key: 'popular', label: 'Popular' }] : [])
      .concat(cats.map(function (c) { return { key: c.toLowerCase(), label: c }; }));
  };

  Customizer.prototype.buildChips = function () {
    var self = this;
    this.dom.patchChips.innerHTML = this.patchCategories().map(function (c) {
      return '<button type="button" class="hg-cc__chip' + (self.state.patchChip === c.key ? ' is-active' : '') +
        '" data-chip="' + esc(c.key) + '">' + esc(c.label) + '</button>';
    }).join('');
  };

  Customizer.prototype.renderPatchGrid = function () {
    var self = this;
    var q = this.state.patchQuery;
    var chip = this.state.patchChip;
    var current = this.state.picks[this.state.view];

    var list = this.data.patches.filter(function (p) {
      if (q && p.title.toLowerCase().indexOf(q) < 0) return false;
      if (chip === 'all') return true;
      if (chip === 'popular') return (p.tags || []).some(function (t) { return /^popular$/i.test(t); });
      return (p.tags || []).some(function (t) {
        var i = t.indexOf(':');
        return i > 0 && t.slice(0, i).trim().toLowerCase() === 'cat' && t.slice(i + 1).trim().toLowerCase() === chip;
      });
    });

    this.dom.patchGrid.innerHTML = '';
    if (!list.length) {
      this.dom.patchGrid.appendChild(el('p', 'hg-cc__empty', 'No patches here yet. Try another category or search.'));
      return;
    }

    list.forEach(function (p) {
      var isCurrent = current && current.id === p.id;
      var b = el('button', 'hg-cc__card hg-cc__card--patch' + (isCurrent ? ' is-active' : ''));
      b.type = 'button';
      b.dataset.patch = p.id;
      b.innerHTML =
        '<span class="hg-cc__card-media">' +
          '<span class="hg-cc__card-check"><svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="3"><path d="M5 13l4 4 10-10"/></svg></span>' +
          (p.thumb ? '<img src="' + esc(p.thumb) + '" alt="" loading="lazy">' : '<span class="hg-cc__card-fallback">No image</span>') +
          '<span class="hg-cc__card-label">' + esc(p.title || 'Untitled patch') + '</span>' +
        '</span>';
      self.dom.patchGrid.appendChild(b);
    });
  };

  /* ---------- price ---------- */

  Customizer.prototype.pickList = function () {
    var self = this;
    return Object.keys(this.state.picks).map(Number).sort(function (a, b) { return a - b; })
      .map(function (v) { return { view: v, patch: self.state.picks[v] }; });
  };

  Customizer.prototype.total = function () {
    var self = this;
    var cap = this.state.cap;
    if (!cap) return 0;
    var variant = cap.variants.find(function (v) { return v.id === self.state.variantId; }) || cap.variants[0];
    var sum = variant ? variant.price : cap.price;
    this.pickList().forEach(function (p) { sum += p.patch.price || 0; });
    return sum;
  };

  Customizer.prototype.updatePrice = function () {
    var self = this;
    var text = money(this.total(), this.data.moneyFormat);
    if (this.dom.price) this.dom.price.textContent = text;
    if (this.dom.priceMobile) this.dom.priceMobile.textContent = text;

    var variant = (this.state.cap.variants || []).find(function (v) { return v.id === self.state.variantId; });
    var ok = !!variant && variant.available;
    this.dom.atc.disabled = !ok;
    if (this.dom.barAtc) this.dom.barAtc.disabled = !ok;
  };

  /* ---------- save ---------- */

  Customizer.prototype.saveDesign = function (btn) {
    try {
      window.sessionStorage.setItem('hg-cc-design', JSON.stringify({
        capId: this.state.cap.id,
        variantId: this.state.variantId,
        picks: this.state.picks
      }));
      btn.classList.add('is-saved');
      this.flash('Design saved to this browser.');
    } catch (e) {
      this.flash('This browser blocked saving. Take a screenshot instead.', true);
    }
  };

  /* ---------- cart drawer ----------
     This theme is Dawn-based but Debutify keys the drawer section by a
     dynamic id published inline as Debutify.cart_drawer_id, so the section
     must be requested by THAT id, not by the literal name "cart-drawer".
     Debutify also exposes Debutify.showCartDrawer(), which opens the drawer
     without going through CartDrawer.open() — open() early-returns unless
     data-type == "drawer", so calling showCartDrawer is the reliable path. */

  Customizer.prototype.drawerId = function () {
    return (window.Debutify && window.Debutify.cart_drawer_id) || null;
  };

  Customizer.prototype.drawerEl = function () {
    if (this.data.drawerSelector) {
      var custom = document.querySelector(this.data.drawerSelector);
      if (custom) return custom;
    }
    return document.querySelector('cart-drawer:not(.in-page-drawer)')
      || document.querySelector('cart-drawer')
      || document.querySelector('cart-notification');
  };

  Customizer.prototype.cartSections = function () {
    if (this.data.afterAdd === 'page') return [];
    var list = [];
    var id = this.drawerId();
    if (id) list.push(id);
    list.push('cart-icon-bubble');
    return list;
  };

  /* Swap the drawer body and the header bubble, mirroring what the theme's
     own refreshCart() does, so the markup stays exactly as Debutify expects. */
  Customizer.prototype.renderCart = function (sections) {
    if (!sections) return false;
    var parser = new DOMParser();
    var rendered = false;

    var id = this.drawerId();
    var drawer = this.drawerEl();

    if (id && sections[id] && drawer) {
      var doc = parser.parseFromString(sections[id], 'text/html');
      var newInner = doc.querySelector('.drawer__inner');
      var oldInner = drawer.querySelector('.drawer__inner');
      if (newInner && oldInner) {
        oldInner.innerHTML = newInner.innerHTML;
        oldInner.classList.remove('is-empty');
        rendered = true;
      }
      var fresh = doc.querySelector('cart-drawer');
      if (fresh && !fresh.classList.contains('is-empty')) drawer.classList.remove('is-empty');
    }

    if (sections['cart-icon-bubble']) {
      var bubbleDoc = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
      var newBubble = bubbleDoc.querySelector('.shopify-section') || bubbleDoc.body.firstElementChild;
      var oldBubble = document.getElementById('cart-icon-bubble');
      if (newBubble && oldBubble) oldBubble.innerHTML = newBubble.innerHTML;
    }

    return rendered;
  };

  /* If the add response carried no sections (drawer id not published yet),
     pull them the same way the theme does. */
  Customizer.prototype.fetchCartSections = function () {
    var self = this;
    var id = this.drawerId();
    if (!id) return Promise.resolve(null);
    return fetch('/cart?sections=' + encodeURIComponent(id) + ',cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (data) { self.renderCart(data); return data; })
      .catch(function () { return null; });
  };

  Customizer.prototype.openDrawer = function () {
    if (window.Debutify && typeof window.Debutify.showCartDrawer === 'function') {
      window.Debutify.showCartDrawer();
      return true;
    }
    var drawer = this.drawerEl();
    if (!drawer) return false;
    drawer.classList.remove('hidden', 'active');
    setTimeout(function () {
      drawer.classList.add('animate', 'active');
      document.body.classList.add('overflow-hidden');
    }, 50);
    return true;
  };

  Customizer.prototype.revealCart = function (body) {
    var self = this;

    if (this.data.afterAdd === 'page') {
      window.location.href = this.data.cartUrl;
      return;
    }

    if (this.data.debug) {
      /* eslint-disable no-console */
      console.group('[hg-cap-customizer] cart drawer');
      console.log('Debutify.cart_drawer_id:', this.drawerId());
      console.log('sections returned:', body && body.sections ? Object.keys(body.sections) : 'none');
      console.log('drawer element:', this.drawerEl());
      console.log('showCartDrawer available:', !!(window.Debutify && window.Debutify.showCartDrawer));
      console.groupEnd();
      /* eslint-enable no-console */
    }

    var rendered = this.renderCart(body && body.sections);

    if (rendered) {
      this.openDrawer();
      this.flash('Added to basket.');
      return;
    }

    // sections missing — fetch them, then open
    this.fetchCartSections().then(function () {
      if (!self.openDrawer()) {
        self.flash('Added to basket. Open your cart to check out.');
        return;
      }
      self.flash('Added to basket.');
    });
  };

  /* ---------- add to cart ---------- */

  Customizer.prototype.addToCart = function (e) {
    var self = this;
    e.preventDefault();

    var picks = this.pickList();
    if (!picks.length) {
      this.flash('Choose a patch before adding to basket.', true);
      this.openLibrary();
      return;
    }

    var bundle = 'HG-' + Date.now().toString(36).toUpperCase();
    var qty = this.state.qty;
    var label = this.dom.atc.textContent;

    this.dom.atc.disabled = true;
    if (this.dom.barAtc) this.dom.barAtc.disabled = true;
    this.dom.atc.textContent = 'Adding…';

    var summary = picks.map(function (p) {
      return p.patch.title + ' (' + (self.data.viewLabels[p.view] || 'View ' + (p.view + 1)) + ')';
    }).join(', ');

    // Everything the cart needs to show ONE finished cap: the patch art, where
    // it sits, and what it adds to the price. The patch line still exists (it
    // has to, for stock and fulfilment) but is flagged _showProduct=false,
    // which this theme already honours in the drawer and the cart bubble.
    var extra = 0;
    picks.forEach(function (p) { extra += p.patch.price || 0; });
    var front = picks[0];

    var capItem = {
      id: Number(this.state.variantId),
      quantity: qty,
      properties: {
        'Patch': summary,
        '_hg_method': this.data.method || '',
        '_hg_bundle': bundle,
        '_hg_role': 'cap',
        '_hg_patch_img': front ? front.patch.art : '',
        '_hg_slot': this.data.slots[String(front ? front.view : 0)] || this.data.slots['0'] || '',
        '_hg_extra': String(extra)
      }
    };

    var patchItems = picks.map(function (p) {
      return {
        id: Number(p.patch.variantId),
        quantity: qty,
        properties: {
          '_showProduct': 'false',
          '_hg_bundle': bundle,
          '_hg_role': 'patch',
          'Applied to': self.state.cap.title,
          'Placement': self.data.viewLabels[p.view] || 'View ' + (p.view + 1)
        }
      };
    });

    var payload = { items: [capItem].concat(patchItems) };
    var sections = this.cartSections();
    if (sections.length) {
      payload.sections = sections.join(',');
      payload.sections_url = window.location.pathname;
    }

    fetch(this.data.cartAddUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body.description || res.body.message || 'Could not add to basket.');
        self.dom.atc.disabled = false;
        if (self.dom.barAtc) self.dom.barAtc.disabled = false;
        self.dom.atc.textContent = label;
        self.revealCart(res.body);
      })
      .catch(function (err) {
        self.dom.atc.disabled = false;
        if (self.dom.barAtc) self.dom.barAtc.disabled = false;
        self.dom.atc.textContent = label;
        self.flash(err.message, true);
      });
  };

  /* ---------- boot ---------- */

  function init() {
    document.querySelectorAll('[data-hg-cc]').forEach(function (root) {
      if (root.dataset.hgReady) return;
      root.dataset.hgReady = '1';
      new Customizer(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function (e) {
    var id = e.detail && e.detail.sectionId;
    if (id) {
      document.querySelectorAll('body > [data-hg-owner="hg-cc-' + id + '"]').forEach(function (n) { n.remove(); });
    }
    init();
  });
})();